class VqCartRecommendation extends HTMLElement {
  connectedCallback() {
    this.loadRecommendation();
  }

  async loadRecommendation() {
    const productId = this.dataset.productId;
    if (!productId || this.dataset.loaded === 'true') return;
    this.dataset.loaded = 'true';

    const root = window.Shopify?.routes?.root || '/';
    const base = `${root}recommendations/products`;

    try {
      let response = await fetch(`${base}?section_id=vq-cart-recommendation&product_id=${encodeURIComponent(productId)}&limit=1&intent=complementary`);
      let html = await response.text();

      if (!html.includes('vq-cart-reco__card')) {
        response = await fetch(`${base}?section_id=vq-cart-recommendation&product_id=${encodeURIComponent(productId)}&limit=1&intent=related`);
        html = await response.text();
      }

      if (html.includes('vq-cart-reco__card')) this.innerHTML = html;
    } catch (error) {
      this.hidden = true;
    }
  }
}

if (!customElements.get('vq-cart-recommendation')) {
  customElements.define('vq-cart-recommendation', VqCartRecommendation);
}
